import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsCalendar } from "react-icons/bs";
import { IoLocationOutline, IoCarOutline } from "react-icons/io5";
import { BiChevronDown } from "react-icons/bi";
import { AiOutlineSearch } from "react-icons/ai";
import { MdOutlineAccessTime } from "react-icons/md";
import { TbLoader2 } from "react-icons/tb";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import transition from "react-element-popper/animations/transition";
import opacity from "react-element-popper/animations/opacity";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import axios from "axios";
import "react-multi-date-picker/styles/layouts/mobile.css";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { message, notification } from "antd";
import Modal from "react-modal";

import Details from "./public/details";
import { setTravel } from "../slices/Travelinfo";
import { StateApp } from "../context/Context";
import Loading from "../Loading/Loading";
import LoginRegister from "../Login/LoginRegister";
import SuccessLogin from "../Modal/Success Login";
import NativeNotificationPrompt from "../pwa/NativeNotificationPrompt";
import { url } from "../url";
import "./trip-booking.css";

const normalizeText = (value) => String(value || "").trim().toLocaleLowerCase();
const formatPrice = (value) => new Intl.NumberFormat("fa-IR").format(value);
const PRICE_PREVIEW_LABELS = {
    loading: "محاسبه قیمت...",
    currency: "تومان",
    unavailable: "قیمت این مسیر در دسترس نیست",
    notCalculated: "قیمت محاسبه نشد",
    selectRoute: "مبدا و مقصد را انتخاب کنید",
};

const Body = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const bookingRef = useRef(null);

    const { userInfo } = useSelector((state) => state.userinformation);
    const { accessToken } = userInfo;
    const {
        setLoading,
        openLogin,
        showSuccessLogin,
    } = useContext(StateApp);

    const [counter, setCounter] = useState(1);
    const [searchVal, setSearchVal] = useState("");
    const [searchDestination, setSearchDestination] = useState("");
    const [inputVal, setInputVal] = useState("");
    const [inputValDestination, setInputValDestination] = useState("");
    const [openLocation, setOpenLocation] = useState(false);
    const [openDestination, setOpenDestination] = useState(false);
    const [openTimePicker, setOpenTimePicker] = useState(false);
    const [carTypeMenu, setCarTypeMenu] = useState(false);

    const [cityName, setCityName] = useState([]);
    const [cityLoading, setCityLoading] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [cityReloadKey, setCityReloadKey] = useState(0);
    const [cityRequested, setCityRequested] = useState(false);

    const [allCarTypes, setAllCarTypes] = useState([]);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [categoryError, setCategoryError] = useState(false);
    const [categoryReloadKey, setCategoryReloadKey] = useState(0);
    const [categoryRequested, setCategoryRequested] = useState(false);
    const [pricePreviewByCategory, setPricePreviewByCategory] = useState({});
    const [pricePreviewLoading, setPricePreviewLoading] = useState(false);
    const [pricePreviewError, setPricePreviewError] = useState(false);

    const [locationId, setLocationId] = useState();
    const [destinationId, setDestinationId] = useState();
    const [gregorianDate, setGregorianDate] = useState("");
    const [selectedHour, setSelectedHour] = useState(null);
    const [selectedMinute, setSelectedMinute] = useState(null);
    const [time, setTime] = useState("انتخاب ساعت");
    const [carTypeName, setCarTypeName] = useState("");
    const [carTypeId, setCarTypeId] = useState("");
    const [acceptTravel, setAcceptTravel] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("antdUpdate") === "true") {
            message.success("اطلاعات با موفقیت ذخیره شد!");
            localStorage.removeItem("antdUpdate");
        }
    }, []);

    useEffect(() => {
        setLoading(false);

        // Let the hero car request start first. Most users will have the city list
        // ready before they interact, without competing with the LCP image.
        const timer = window.setTimeout(() => setCityRequested(true), 700);
        return () => window.clearTimeout(timer);
    }, [setLoading]);

    useEffect(() => {
        if (!cityRequested) return undefined;

        setCityLoading(true);
        setCityError(false);

        axios.get(`${url}/states/v1/get-city-list`, {
            params: { withoutPagination: true },
        })
            .then((response) => {
                const cities = Array.isArray(response?.data?.data) ? response.data.data : [];
                setCityName(cities);
            })
            .catch(() => {
                setCityError(true);
            })
            .finally(() => {
                setCityLoading(false);
            });

        return undefined;
    }, [cityReloadKey, cityRequested]);

    useEffect(() => {
        if (!categoryRequested) return undefined;

        setCategoryLoading(true);
        setCategoryError(false);

        const savedToken = localStorage.getItem("accessToken");
        const config = savedToken
            ? { headers: { Authorization: `Bearer ${savedToken}` } }
            : {};

        axios.get(`${url}/cars/v1/get-cars-of-category-list`, config)
            .then((response) => {
                const categories = Array.isArray(response?.data?.data) ? response.data.data : [];
                setAllCarTypes(categories);
            })
            .catch(() => {
                setCategoryError(true);
            })
            .finally(() => {
                setCategoryLoading(false);
            });

        return undefined;
    }, [categoryReloadKey, categoryRequested]);

    useEffect(() => {
        const sameRoute = String(locationId) === String(destinationId);
        if (!locationId || !destinationId || sameRoute) {
            setPricePreviewByCategory({});
            setPricePreviewLoading(false);
            setPricePreviewError(false);
            return undefined;
        }

        const controller = new AbortController();
        let canceled = false;
        setPricePreviewLoading(true);
        setPricePreviewError(false);
        setPricePreviewByCategory({});

        axios.get(`${url}/travel/v1/preview-car-prices`, {
            params: {
                origin_city: locationId,
                destination_city: destinationId,
            },
            signal: controller.signal,
        })
            .then((response) => {
                if (canceled) return;
                const previews = Array.isArray(response?.data?.data) ? response.data.data : [];
                const prices = previews.reduce((result, item) => {
                    const categoryId = item?.car_category?._id || item?._id;
                    const price = Number(item?.price);
                    if (categoryId && Number.isFinite(price)) {
                        result[String(categoryId)] = price;
                    }
                    return result;
                }, {});
                setPricePreviewByCategory(prices);
            })
            .catch((error) => {
                if (canceled || axios.isCancel(error)) return;
                setPricePreviewByCategory({});
                setPricePreviewError(true);
            })
            .finally(() => {
                if (!canceled) setPricePreviewLoading(false);
            });

        return () => {
            canceled = true;
            controller.abort();
        };
    }, [locationId, destinationId]);

    useEffect(() => {
        if (!carTypeId || !allCarTypes.length) return;
        const categoryStillExists = allCarTypes.some(
            (item) => String(item?.car_category?._id) === String(carTypeId)
        );
        if (!categoryStillExists) {
            setCarTypeId("");
            setCarTypeName("");
        }
    }, [allCarTypes, carTypeId]);

    useEffect(() => {
        const handleOutsidePointer = (event) => {
            if (!bookingRef.current || bookingRef.current.contains(event.target)) return;
            setOpenLocation(false);
            setOpenDestination(false);
            setOpenTimePicker(false);
            setCarTypeMenu(false);
        };

        document.addEventListener("pointerdown", handleOutsidePointer);
        return () => document.removeEventListener("pointerdown", handleOutsidePointer);
    }, []);

    const filteredOriginCities = useMemo(() => {
        const query = normalizeText(searchVal);
        if (!query) return cityName;
        return cityName.filter((city) => normalizeText(city?.name).includes(query));
    }, [cityName, searchVal]);

    const filteredDestinationCities = useMemo(() => {
        const query = normalizeText(searchDestination);
        if (!query) return cityName;
        return cityName.filter((city) => normalizeText(city?.name).includes(query));
    }, [cityName, searchDestination]);

    const scrollToBooking = () => {
        document.getElementById("tripManagement")?.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const handleOpenLocation = () => {
        scrollToBooking();
        if (!cityRequested && !cityName.length) setCityLoading(true);
        setCityRequested(true);
        setOpenLocation((previous) => !previous);
        setOpenDestination(false);
        setOpenTimePicker(false);
        setCarTypeMenu(false);
    };

    const handleOpenDestination = () => {
        scrollToBooking();
        if (!cityRequested && !cityName.length) setCityLoading(true);
        setCityRequested(true);
        setOpenDestination((previous) => !previous);
        setOpenLocation(false);
        setOpenTimePicker(false);
        setCarTypeMenu(false);
    };

    const handleTimePicker = () => {
        setOpenTimePicker((previous) => !previous);
        setOpenLocation(false);
        setOpenDestination(false);
        setCarTypeMenu(false);
    };

    const handleCarTypeMenu = () => {
        if (!carTypeMenu && !allCarTypes.length) {
            setCategoryLoading(true);
            setCategoryRequested(true);
        }
        setCarTypeMenu((previous) => !previous);
        setOpenLocation(false);
        setOpenDestination(false);
        setOpenTimePicker(false);
    };

    const handleDateChange = (date) => {
        if (!date) {
            setGregorianDate("");
            return;
        }
        setGregorianDate(date.convert(gregorian, gregorian_en).format("YYYY-MM-DD"));
    };

    const hours = Array.from({ length: 24 }, (_, index) => index);
    const minutes = [0, 15, 30, 45];

    const handleTime = () => {
        if (selectedHour === null || selectedMinute === null) {
            notification.warning({
                message: "ساعت حرکت کامل نیست",
                description: "لطفاً ساعت و دقیقه را انتخاب کنید.",
                placement: "topRight",
            });
            return;
        }

        setTime(`${selectedHour.toString().padStart(2, "0")}:${selectedMinute.toString().padStart(2, "0")}`);
        setOpenTimePicker(false);
    };

    const selectOrigin = (city) => {
        setInputVal(city?.name || "");
        setLocationId(city?._id);
        const latitude = Number(city?.latitude);
        const longitude = Number(city?.longitude);
        if (Number.isFinite(latitude) && latitude >= -90 && latitude <= 90) {
            localStorage.setItem("lat", String(latitude));
        } else {
            localStorage.removeItem("lat");
        }
        if (Number.isFinite(longitude) && longitude >= -180 && longitude <= 180) {
            localStorage.setItem("long", String(longitude));
        } else {
            localStorage.removeItem("long");
        }
        setOpenLocation(false);
        setSearchVal("");
    };

    const selectDestination = (city) => {
        setInputValDestination(city?.name || "");
        setDestinationId(city?._id);
        setOpenDestination(false);
        setSearchDestination("");
    };

    const selectCarType = (item) => {
        setCarTypeId(item?.car_category?._id || "");
        setCarTypeName(item?.car_category?.name || "");
        setCarTypeMenu(false);
    };

    const incrementCounter = () => {
        if (counter < 4) {
            setCounter((previous) => previous + 1);
            return;
        }

        notification.error({ message: "حداکثر ۴ مسافر قابل ثبت است." });
    };

    const decrementCounter = () => {
        if (counter > 1) setCounter((previous) => previous - 1);
    };

    const validateTravelForm = () => {
        const missing = [];
        if (!locationId) missing.push("مبدا");
        if (!destinationId) missing.push("مقصد");
        if (!gregorianDate) missing.push("تاریخ سفر");
        if (time === "انتخاب ساعت") missing.push("ساعت حرکت");
        if (!carTypeId) missing.push("نوع خودرو");

        if (missing.length) {
            notification.warning({
                message: "اطلاعات سفر کامل نیست",
                description: `لطفاً ${missing.join("، ")} را انتخاب کنید.`,
                placement: "topRight",
            });
            return false;
        }

        if (locationId === destinationId) {
            notification.warning({
                message: "مبدا و مقصد یکسان است",
                description: "لطفاً مقصد دیگری انتخاب کنید.",
                placement: "topRight",
            });
            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (acceptTravel || !validateTravelForm()) return;

        const authToken = accessToken || localStorage.getItem("accessToken");
        if (!authToken) {
            notification.error({
                message: "ابتدا وارد حساب کاربری شوید",
                placement: "topRight",
            });
            setIsModalOpen(true);
            return;
        }

        const requestData = {
            origin_city: locationId,
            destination_city: destinationId,
            travel_date: gregorianDate,
            travel_hour_time: time,
            car_type_id: carTypeId,
            passenger_count: counter,
        };

        setAcceptTravel(true);

        axios.post(`${url}/travel/v1/create-new-travel`, requestData, {
            headers: { Authorization: `Bearer ${authToken}` },
        })
            .then((response) => {
                const createdTravelId = response?.data?.data?._id;
                if (!createdTravelId) throw new Error("شناسه سفر از سرور دریافت نشد");

                Cookies.set("TravelId", createdTravelId);
                dispatch(setTravel({
                    travelId: createdTravelId,
                    origin: locationId,
                    destination: destinationId,
                    carType: carTypeId,
                }));

                navigate(`/passenger/${createdTravelId}`);
                window.scrollTo({ top: 0, behavior: "auto" });
            })
            .catch((error) => {
                const status = error?.response?.status || error?.response?.data?.status;

                if ([401, 403].includes(status)) {
                    setIsModalOpen(true);
                    notification.error({
                        message: status === 401
                            ? "ابتدا وارد حساب کاربری شوید"
                            : (error?.response?.data?.message || "دسترسی شما برای این عملیات کافی نیست"),
                        placement: "topRight",
                    });
                    return;
                }

                if (status === 409) {
                    notification.error({
                        message: error?.response?.data?.message || "امکان ثبت این سفر وجود ندارد",
                        placement: "topRight",
                    });
                    return;
                }

                if (error?.message === "Network Error") {
                    notification.error({
                        message: "خطا در اتصال به اینترنت",
                        description: "اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.",
                        placement: "topRight",
                    });
                    return;
                }

                if (status === 404) {
                    notification.error({
                        message: error?.response?.data?.message || "اطلاعات موردنظر پیدا نشد",
                        placement: "topRight",
                    });
                    return;
                }

                notification.error({
                    message: error?.response?.data?.message || "خطا در ثبت درخواست سفر",
                    placement: "topRight",
                });
            })
            .finally(() => {
                setAcceptTravel(false);
            });
    };

    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            padding: 0,
            transform: "translate(-50%, -50%)",
            position: "absolute",
            borderRadius: "10px",
            outline: "none",
            border: "none",
        },
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
    };

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                style={customStyles}
                className="modalMobile"
            >
                <button
                    className="custom-modal-close"
                    onClick={() => setIsModalOpen(false)}
                    aria-label="بستن"
                >
                    &times;
                </button>
                {openLogin ? <LoginRegister /> : showSuccessLogin ? <SuccessLogin /> : null}
            </Modal>

            <NativeNotificationPrompt accessToken={accessToken} />

            <section className="tb-wrap" aria-label="ثبت درخواست سفر">
                <div className="tb-card">
                    <div id="tripManagement" className="tb-row" ref={bookingRef}>
                        <div className={`tb-field ${inputVal ? "is-filled" : ""} ${openLocation ? "is-open" : ""}`}>
                            <button
                                type="button"
                                className="tb-trigger"
                                onClick={handleOpenLocation}
                                aria-expanded={openLocation}
                            >
                                <span className="tb-icon"><IoLocationOutline size={18} /></span>
                                <span className="tb-texts">
                                    <span className="tb-label">مبدا</span>
                                    <span className={`tb-value ${inputVal ? "" : "is-placeholder"}`}>
                                        {inputVal || "انتخاب شهر"}
                                    </span>
                                </span>
                                <BiChevronDown className={`tb-chevron ${openLocation ? "is-open" : ""}`} size={20} />
                            </button>

                            {openLocation && (
                                <div className="tb-dropdown is-open">
                                    <div className="tb-search">
                                        <AiOutlineSearch size={16} className="tb-search-icon" />
                                        <input
                                            value={searchVal}
                                            onChange={(event) => setSearchVal(event.target.value)}
                                            type="search"
                                            placeholder="جستجوی شهر..."
                                            autoFocus
                                            aria-label="جستجوی شهر مبدا"
                                        />
                                    </div>
                                    <ul className="tb-list">
                                        {cityLoading ? (
                                            <li className="tb-status"><TbLoader2 className="tb-spin" /> در حال دریافت شهرها...</li>
                                        ) : cityError ? (
                                            <li className="tb-status tb-status-error">
                                                <span>دریافت شهرها ناموفق بود.</span>
                                                <button type="button" className="tb-retry" onClick={() => setCityReloadKey((value) => value + 1)}>
                                                    تلاش مجدد
                                                </button>
                                            </li>
                                        ) : filteredOriginCities.length ? (
                                            filteredOriginCities.map((city) => (
                                                <li key={city?._id || city?.name}>
                                                    <button type="button" className="tb-item" onClick={() => selectOrigin(city)}>
                                                        <span className="tb-item-pin"><IoLocationOutline size={15} /></span>
                                                        <span>{city?.name}</span>
                                                    </button>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="tb-empty">شهری با این نام پیدا نشد.</li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div className="tb-sep" />

                        <div className={`tb-field ${inputValDestination ? "is-filled" : ""} ${openDestination ? "is-open" : ""}`}>
                            <button
                                type="button"
                                className="tb-trigger"
                                onClick={handleOpenDestination}
                                aria-expanded={openDestination}
                            >
                                <span className="tb-icon"><IoLocationOutline size={18} /></span>
                                <span className="tb-texts">
                                    <span className="tb-label">مقصد</span>
                                    <span className={`tb-value ${inputValDestination ? "" : "is-placeholder"}`}>
                                        {inputValDestination || "انتخاب شهر"}
                                    </span>
                                </span>
                                <BiChevronDown className={`tb-chevron ${openDestination ? "is-open" : ""}`} size={20} />
                            </button>

                            {openDestination && (
                                <div className="tb-dropdown is-open">
                                    <div className="tb-search">
                                        <AiOutlineSearch size={16} className="tb-search-icon" />
                                        <input
                                            value={searchDestination}
                                            onChange={(event) => setSearchDestination(event.target.value)}
                                            type="search"
                                            placeholder="جستجوی شهر..."
                                            autoFocus
                                            aria-label="جستجوی شهر مقصد"
                                        />
                                    </div>
                                    <ul className="tb-list">
                                        {cityLoading ? (
                                            <li className="tb-status"><TbLoader2 className="tb-spin" /> در حال دریافت شهرها...</li>
                                        ) : cityError ? (
                                            <li className="tb-status tb-status-error">
                                                <span>دریافت شهرها ناموفق بود.</span>
                                                <button type="button" className="tb-retry" onClick={() => setCityReloadKey((value) => value + 1)}>
                                                    تلاش مجدد
                                                </button>
                                            </li>
                                        ) : filteredDestinationCities.length ? (
                                            filteredDestinationCities.map((city) => (
                                                <li key={city?._id || city?.name}>
                                                    <button type="button" className="tb-item" onClick={() => selectDestination(city)}>
                                                        <span className="tb-item-pin"><IoLocationOutline size={15} /></span>
                                                        <span>{city?.name}</span>
                                                    </button>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="tb-empty">شهری با این نام پیدا نشد.</li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div className="tb-sep" />

                        <div className="tb-pair">
                            <div
                                className={`tb-field ${gregorianDate ? "is-filled" : ""}`}
                                onClickCapture={() => {
                                    setOpenLocation(false);
                                    setOpenDestination(false);
                                    setOpenTimePicker(false);
                                    setCarTypeMenu(false);
                                }}
                            >
                                <div className="tb-trigger tb-trigger-static">
                                    <span className="tb-icon"><BsCalendar size={15} /></span>
                                    <span className="tb-texts">
                                        <span className="tb-label">تاریخ سفر</span>
                                        <DatePicker
                                            animations={[
                                                opacity(),
                                                transition({
                                                    from: 40,
                                                    transition: "all 300ms cubic-bezier(0.335, 0.010, 0.030, 1.200)",
                                                }),
                                            ]}
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition="bottom-right"
                                            placeholder="انتخاب تاریخ"
                                            className="md:rmdp-mobile cursor-pointer"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                                outline: "none",
                                                backgroundColor: "transparent",
                                                fontFamily: "inherit",
                                                fontSize: "13.5px",
                                                fontWeight: 600,
                                                padding: 0,
                                            }}
                                            format="DD MMMM"
                                            onChange={handleDateChange}
                                        />
                                    </span>
                                </div>
                            </div>

                            <div className="tb-sep" />

                            <div className={`tb-field ${time !== "انتخاب ساعت" ? "is-filled" : ""} ${openTimePicker ? "is-open" : ""}`}>
                                <button
                                    type="button"
                                    className="tb-trigger"
                                    onClick={handleTimePicker}
                                    aria-expanded={openTimePicker}
                                >
                                    <span className="tb-icon"><MdOutlineAccessTime size={18} /></span>
                                    <span className="tb-texts">
                                        <span className="tb-label">ساعت حرکت</span>
                                        <span className={`tb-value ${time !== "انتخاب ساعت" ? "" : "is-placeholder"}`} style={{ fontFamily: "IRANSansFaNum" }}>
                                            {time}
                                        </span>
                                    </span>
                                    <BiChevronDown className={`tb-chevron ${openTimePicker ? "is-open" : ""}`} size={20} />
                                </button>

                                {openTimePicker && (
                                    <div className="tb-dropdown is-open">
                                        <div className="tb-time">
                                            <div className="tb-time-cols">
                                                <div className="tb-time-col">
                                                    <p className="tb-time-head">دقیقه</p>
                                                    <ul>
                                                        {minutes.map((minute) => (
                                                            <li key={minute}>
                                                                <button
                                                                    type="button"
                                                                    className={selectedMinute === minute ? "is-active" : ""}
                                                                    style={{ fontFamily: "IRANSansFaNum" }}
                                                                    onClick={() => setSelectedMinute(minute)}
                                                                >
                                                                    {minute.toString().padStart(2, "0")}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className="tb-time-col">
                                                    <p className="tb-time-head">ساعت</p>
                                                    <ul className="tb-hours">
                                                        {hours.map((hour) => (
                                                            <li key={hour}>
                                                                <button
                                                                    type="button"
                                                                    className={selectedHour === hour ? "is-active" : ""}
                                                                    onClick={() => setSelectedHour(hour)}
                                                                    style={{ fontFamily: "IRANSansFaNum" }}
                                                                >
                                                                    {hour.toString().padStart(2, "0")}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                            <button type="button" onClick={handleTime} className="tb-time-ok">
                                                ثبت ساعت
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="tb-sep" />

                        <div className="tb-pair">
                            <div className={`tb-field ${carTypeName ? "is-filled" : ""} ${carTypeMenu ? "is-open" : ""}`}>
                                <button
                                    type="button"
                                    className="tb-trigger"
                                    onClick={handleCarTypeMenu}
                                    aria-expanded={carTypeMenu}
                                >
                                    <span className="tb-icon"><IoCarOutline size={18} /></span>
                                    <span className="tb-texts">
                                        <span className="tb-label">نوع خودرو</span>
                                        <span className={`tb-value ${carTypeName ? "" : "is-placeholder"}`}>
                                            {carTypeName || "انتخاب کلاس"}
                                        </span>
                                    </span>
                                    <BiChevronDown className={`tb-chevron ${carTypeMenu ? "is-open" : ""}`} size={20} />
                                </button>

                                {carTypeMenu && (
                                    <div className="tb-dropdown is-open">
                                        <div className="tb-cars">
                                            {categoryLoading ? (
                                                <div className="tb-status"><TbLoader2 className="tb-spin" /> در حال دریافت کلاس خودرو...</div>
                                            ) : categoryError ? (
                                                <div className="tb-status tb-status-error">
                                                    <span>دریافت کلاس خودرو ناموفق بود.</span>
                                                    <button type="button" className="tb-retry" onClick={() => setCategoryReloadKey((value) => value + 1)}>
                                                        تلاش مجدد
                                                    </button>
                                                </div>
                                            ) : allCarTypes.length ? (
                                                allCarTypes.map((item, index) => {
                                                    const examples = Array.isArray(item?.car_list) ? item.car_list.slice(0, 3) : [];
                                                    const categoryId = item?.car_category?._id;
                                                    const categoryPrice = pricePreviewByCategory[String(categoryId)];
                                                    const hasRoute = Boolean(
                                                        locationId &&
                                                        destinationId &&
                                                        String(locationId) !== String(destinationId)
                                                    );

                                                    return (
                                                        <button
                                                            type="button"
                                                            className={`tb-car ${carTypeId === categoryId ? "is-active" : ""}`}
                                                            key={categoryId || index}
                                                            onClick={() => selectCarType(item)}
                                                        >
                                                            <span className="tb-car-name">{item?.car_category?.name || "کلاس خودرو"}</span>
                                                            <span className="tb-car-price" style={{ fontFamily: "IRANSansFaNum" }}>
                                                                {pricePreviewLoading && hasRoute ? (
                                                                    <><TbLoader2 className="tb-spin" /> {PRICE_PREVIEW_LABELS.loading}</>
                                                                ) : Number.isFinite(categoryPrice) ? (
                                                                    <>{formatPrice(categoryPrice)} {PRICE_PREVIEW_LABELS.currency}</>
                                                                ) : hasRoute && pricePreviewError ? (
                                                                    PRICE_PREVIEW_LABELS.unavailable
                                                                ) : hasRoute ? (
                                                                    PRICE_PREVIEW_LABELS.notCalculated
                                                                ) : (
                                                                    PRICE_PREVIEW_LABELS.selectRoute
                                                                )}
                                                            </span>
                                                            <span className="tb-car-examples">
                                                                {examples.length ? examples.map((car, carIndex) => (
                                                                    <span className="tb-chip" key={car?._id || `${car?.name}-${carIndex}`}>
                                                                        {car?.name}
                                                                    </span>
                                                                )) : (
                                                                    <span className="tb-chip is-empty">---</span>
                                                                )}
                                                            </span>
                                                        </button>
                                                    );
                                                })
                                            ) : (
                                                <div className="tb-empty">کلاس خودرویی برای نمایش وجود ندارد.</div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="tb-counter" aria-label="تعداد مسافر">
                                <button type="button" onClick={incrementCounter} className="tb-count-btn" aria-label="افزایش تعداد مسافر">
                                    +
                                </button>
                                <p className="tb-count-label" aria-live="polite">
                                    <span className="tb-count-num" style={{ fontFamily: "IRANSansFaNum" }}>{counter}</span>
                                    <span className="tb-count-text">مسافر</span>
                                </p>
                                <button type="button" onClick={decrementCounter} className="tb-count-btn" aria-label="کاهش تعداد مسافر">
                                    -
                                </button>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="tb-submit"
                            disabled={acceptTravel}
                            aria-busy={acceptTravel}
                        >
                            {acceptTravel ? <Loading /> : <span>ثبت درخواست</span>}
                        </button>
                    </div>
                </div>
            </section>

            <Details />
        </>
    );
};

export default Body;
